import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const getAuthToken = () => {
    const adminData = sessionStorage.getItem('adminkhadamat');
    if (adminData) {
        try {
            const parsed = JSON.parse(adminData);
            // البحث عن التوكن في أماكن مختلفة
            if (parsed.data?.token?.access_token) {
              const token = String(parsed.data.token.access_token);
              return token;
            }
            if (parsed.data?.access_token) return parsed.data.access_token;
            if (parsed.data?.token) return parsed.data.token;
            if (parsed.token) return parsed.token;
            if (parsed.result?.token) return parsed.result.token;
            if (parsed.user?.token) return parsed.user.token;
            return null;
        } catch {
            return null;
        }
    }
    return null;
};

// Fetch all products
export const fetchAdminProducts = createAsyncThunk(
    'adminProducts/fetchAdminProducts',
    async ({ page = 1, search = '', category_id = '', subcategory_id = '', store_id = '' }, { rejectWithValue }) => {
        try {
            const token = getAuthToken();
            const params = { page };
            if (search) params.search = search;
            if (category_id) params.category_id = category_id;
            if (subcategory_id) params.subcategory_id = subcategory_id;
            if (store_id) params.store_id = store_id;

            const response = await axios.get(`${BASE_URL}/admin/products`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
                params
            });

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في جلب المنتجات');
        }
    }
);

// Fetch product details
export const fetchAdminProductDetails = createAsyncThunk(
    'adminProducts/fetchAdminProductDetails',
    async (productId, { rejectWithValue }) => {
        try {
            const token = getAuthToken();
            const response = await axios.get(`${BASE_URL}/admin/products/${productId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept-Language': 'ar',
                    'lang': 'ar',
                },
            });

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في جلب تفاصيل المنتج');
        }
    }
);

const adminProductsSlice = createSlice({
    name: 'adminProducts',
    initialState: {
        products: [],
        productDetails: null,
        pagination: null,
        loading: false,
        detailsLoading: false,
        error: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearProductDetails: (state) => {
            state.productDetails = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Products
            .addCase(fetchAdminProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAdminProducts.fulfilled, (state, action) => {
                state.loading = false;
     
                
                // البيانات تأتي في action.payload.message.data
                state.products = action.payload.message?.data || [];
                state.pagination = action.payload.message?.pagination || null;
            })
            .addCase(fetchAdminProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Fetch Product Details
            .addCase(fetchAdminProductDetails.pending, (state) => {
                state.detailsLoading = true;
                state.error = null;
            })
            .addCase(fetchAdminProductDetails.fulfilled, (state, action) => {
                state.detailsLoading = false;
                state.productDetails = action.payload.message;
            })
            .addCase(fetchAdminProductDetails.rejected, (state, action) => {
                state.detailsLoading = false;
                state.error = action.payload;
            });
    },
});

export const { clearError, clearProductDetails } = adminProductsSlice.actions;
export default adminProductsSlice.reducer;

